import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const productTypeApi = createApi({
  reducerPath: "productType",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["ProductType"],
  keepUnusedDataFor: 300,
  endpoints(builder) {
    return {
      deleteProductType: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productTypes/storageRoles/delete-product-type",
            "DELETE"
          );
        },
        invalidatesTags: ["ProductType"],
      }),
      addProductType: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productTypes/storageRoles/create-product-type",
            "POST"
          );
        },
        invalidatesTags: ["ProductType"],
      }),
      updateProductType: builder.mutation({
        query: (input) => {
          return apiFunction(
            input,
            "/api/productTypes/storageRoles/update-product-type",
            "PATCH"
          );
        },
        invalidatesTags: ["ProductType"],
      }),
      fetchProductType: builder.query({
        query: (token) => {
          return apiFunction(
            { token },
            "/api/productTypes/storageRoles/get-all-product-types",
            "POST"
          );
        },
        providesTags: ["ProductType"],
      }),
    };
  },
});

export const {
  useFetchProductTypeQuery,
  useAddProductTypeMutation,
  useUpdateProductTypeMutation,
  useDeleteProductTypeMutation,
} = productTypeApi;
export { productTypeApi };
